/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetInventoryStockItemsList,
  InventoryStockPosition,
  InventoryStockPositionInput,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Fleet Inventory Stock
 */
export const fleetInventoryStock = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetInventorySlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetInventorySlug = toValue(fleetInventorySlug);

      return axiosClient<FleetInventoryStockItemsList>(
      {url: `/fleets/${fleetSlug}/inventories/${fleetInventorySlug}/stock`, method: 'GET', signal
    },
      );
    }




export const getFleetInventoryStockQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    fleetInventorySlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'inventories',fleetInventorySlug,'stock'
    ] as const;
    }


export const getFleetInventoryStockQueryOptions = <TData = Awaited<ReturnType<typeof fleetInventoryStock>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    fleetInventorySlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInventoryStock>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetInventoryStockQueryKey(fleetSlug,fleetInventorySlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetInventoryStock>>> = ({ signal }) => fleetInventoryStock(fleetSlug,fleetInventorySlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined && toValue(fleetInventorySlug) !== null && toValue(fleetInventorySlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetInventoryStock>>, TError, TData>
}

export type FleetInventoryStockQueryResult = NonNullable<Awaited<ReturnType<typeof fleetInventoryStock>>>
export type FleetInventoryStockQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Inventory Stock
 */

export function useFleetInventoryStock<TData = Awaited<ReturnType<typeof fleetInventoryStock>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    fleetInventorySlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInventoryStock>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetInventoryStockQueryOptions(fleetSlug,fleetInventorySlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Fleet Inventory Stock Position
 */
export const fleetInventoryStockItem = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetInventorySlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetInventorySlug = toValue(fleetInventorySlug);
slug = toValue(slug);

      return axiosClient<InventoryStockPosition>(
      {url: `/fleets/${fleetSlug}/inventories/${fleetInventorySlug}/stock/${slug}`, method: 'GET', signal
    },
      );
    }




export const getFleetInventoryStockItemQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    fleetInventorySlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'inventories',fleetInventorySlug,'stock',slug
    ] as const;
    }


export const getFleetInventoryStockItemQueryOptions = <TData = Awaited<ReturnType<typeof fleetInventoryStockItem>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    fleetInventorySlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInventoryStockItem>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetInventoryStockItemQueryKey(fleetSlug,fleetInventorySlug,slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetInventoryStockItem>>> = ({ signal }) => fleetInventoryStockItem(fleetSlug,fleetInventorySlug,slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined && toValue(fleetInventorySlug) !== null && toValue(fleetInventorySlug) !== undefined && toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetInventoryStockItem>>, TError, TData>
}

export type FleetInventoryStockItemQueryResult = NonNullable<Awaited<ReturnType<typeof fleetInventoryStockItem>>>
export type FleetInventoryStockItemQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Inventory Stock Position
 */

export function useFleetInventoryStockItem<TData = Awaited<ReturnType<typeof fleetInventoryStockItem>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    fleetInventorySlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInventoryStockItem>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetInventoryStockItemQueryOptions(fleetSlug,fleetInventorySlug,slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Fleet Inventory Stock Position
 */
export const updateFleetInventoryStockItem = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetInventorySlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    inventoryStockPositionInput: MaybeRefOrGetter<InventoryStockPositionInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetInventorySlug = toValue(fleetInventorySlug);
slug = toValue(slug);
inventoryStockPositionInput = toValue(inventoryStockPositionInput);

      return axiosClient<InventoryStockPosition>(
      {url: `/fleets/${fleetSlug}/inventories/${fleetInventorySlug}/stock/${slug}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: inventoryStockPositionInput, signal
    },
      );
    }




export const getUpdateFleetInventoryStockItemMutationKey = () => ['updateFleetInventoryStockItem'] as const;

export const getUpdateFleetInventoryStockItemMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetInventoryStockItem>>, TError,UpdateFleetInventoryStockItemMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetInventoryStockItem>>, TError,UpdateFleetInventoryStockItemMutationVariables, TContext> => {

const mutationKey = getUpdateFleetInventoryStockItemMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetInventoryStockItem>>, UpdateFleetInventoryStockItemMutationVariables> = (props) => {
          const {fleetSlug,fleetInventorySlug,slug,data} = props ?? {};

          return  updateFleetInventoryStockItem(fleetSlug,fleetInventorySlug,slug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetInventoryStockItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetInventoryStockItem>>>
    export type UpdateFleetInventoryStockItemMutationBody = InventoryStockPositionInput
    export type UpdateFleetInventoryStockItemMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateFleetInventoryStockItemMutationVariables = {fleetSlug: string;fleetInventorySlug: string;slug: string;data: InventoryStockPositionInput}

    /**
 * @summary Update Fleet Inventory Stock Position
 */
export const useUpdateFleetInventoryStockItem = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetInventoryStockItem>>, TError,UpdateFleetInventoryStockItemMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetInventoryStockItem>>,
        TError,
        UpdateFleetInventoryStockItemMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFleetInventoryStockItemMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Fleet Inventory Stock Position
 */
export const destroyFleetInventoryStockItem = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetInventorySlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetInventorySlug = toValue(fleetInventorySlug);
slug = toValue(slug);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/inventories/${fleetInventorySlug}/stock/${slug}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetInventoryStockItemMutationKey = () => ['destroyFleetInventoryStockItem'] as const;

export const getDestroyFleetInventoryStockItemMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetInventoryStockItem>>, TError,DestroyFleetInventoryStockItemMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetInventoryStockItem>>, TError,DestroyFleetInventoryStockItemMutationVariables, TContext> => {

const mutationKey = getDestroyFleetInventoryStockItemMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetInventoryStockItem>>, DestroyFleetInventoryStockItemMutationVariables> = (props) => {
          const {fleetSlug,fleetInventorySlug,slug} = props ?? {};

          return  destroyFleetInventoryStockItem(fleetSlug,fleetInventorySlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetInventoryStockItemMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetInventoryStockItem>>>

    export type DestroyFleetInventoryStockItemMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyFleetInventoryStockItemMutationVariables = {fleetSlug: string;fleetInventorySlug: string;slug: string}

    /**
 * @summary Delete Fleet Inventory Stock Position
 */
export const useDestroyFleetInventoryStockItem = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetInventoryStockItem>>, TError,DestroyFleetInventoryStockItemMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetInventoryStockItem>>,
        TError,
        DestroyFleetInventoryStockItemMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyFleetInventoryStockItemMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleet All Inventory Stock
 */
export const fleetAllInventoryStock = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<FleetInventoryStockItemsList>(
      {url: `/fleets/${fleetSlug}/inventory-stock`, method: 'GET', signal
    },
      );
    }




export const getFleetAllInventoryStockQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'inventory-stock'
    ] as const;
    }


export const getFleetAllInventoryStockQueryOptions = <TData = Awaited<ReturnType<typeof fleetAllInventoryStock>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetAllInventoryStock>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetAllInventoryStockQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetAllInventoryStock>>> = ({ signal }) => fleetAllInventoryStock(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetAllInventoryStock>>, TError, TData>
}

export type FleetAllInventoryStockQueryResult = NonNullable<Awaited<ReturnType<typeof fleetAllInventoryStock>>>
export type FleetAllInventoryStockQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet All Inventory Stock
 */

export function useFleetAllInventoryStock<TData = Awaited<ReturnType<typeof fleetAllInventoryStock>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetAllInventoryStock>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetAllInventoryStockQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






